import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  AppBar,
  Button as Btn,
  DialogActions,
  Divider,
  Grid,
  MenuItem,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Editor,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../../components/v2/styled';
import { Base } from '../Base';

import { KnowledgeCourse } from '../../../../models/KnowledgeCourse';
import { Questionnaire } from '../../../../models/Questionnaire';
import { KnowledgeSubject } from '../../../../models/KnowledgeSubject';

import HelpersLanguage from '../../../../actions/helpers/language';

// const { DateTime } = require("luxon");

type Props = {
  knowledgeCourse: KnowledgeCourse;
  objectId?: number;
  setObjectId?: (n?:number) => void;
  refetchSubjects: () => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  subjects?: KnowledgeSubject[];
};

export const KnowledgeAddSubject: FunctionComponent<Props> = ({refetchSubjects, knowledgeCourse, objectId, setObjectId, open, setOpen, subjects}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  const [mainObject, setMainObject] = useState<KnowledgeSubject>({
    name: '',
    weight: (subjects || []).length * 10 + 10
  });
  const [currentLanguageId, setCurrentLanguageId] = useState<number>(1);
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["knowledge_subject", objectId],
    queryFn: () =>
      fetch_one<KnowledgeSubject>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_subject',
          id: objectId,
          fields: [
            'id', 'full_name', 'full_body', 'knowledge_course_id', 'quiz_id', 'is_open_order', 'weight', 'extra_data'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!objectId,
  });

  const {
    data: questionnaires,
    // isLoading: objectsLoading,
    // isError: objectsError,
    isSuccess: questionnairesSuccess,
    refetch: questionnairesRefetch,
  } = useQuery({
    queryKey: ["coach", "questionnaires", (login?.practice_id || currentPractice?.id)],
    queryFn: () =>
      fetch_all<Questionnaire>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'questionnaire',
          fields: ['id', 'name', 'content_type'],
          order: 'name ASC',
          per_page: 200,
          page: 0,
          filter: {
            search: '',
            advanced: {
              only_for_knowledge: 1,
              practice_id: (login?.practice_id || currentPractice?.id)
            }
          },
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    enabled: !!(login?.practice_id || currentPractice?.id),
  });










  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<KnowledgeSubject>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      refetchSubjects();
      // setMainObject({name: ''});

      setFlickerEditor(true);
      setTimeout(() => {
        setFlickerEditor(false);
        if (!!setObjectId) setObjectId(undefined);
        setOpen(false);
      }, 200);
    },
  });




  










  const saveObject = () => {
    let data = new FormData();
    data.append('object', 'knowledge_subject');
    data.append('handler_id', login?.id?.toString() || '');
    data.append('practice_id', (login?.practice_id || currentPractice?.id || '').toString() || '');
    if (!!mainObject?.id) data.append('id', mainObject?.id?.toString() || '');
    if (!!mainObject?.id) data.append('ob[id]', mainObject?.id?.toString() || '');
    data.append('ob[knowledge_course_id]', knowledgeCourse?.id?.toString() || '');
    data.append('ob[body]', (mainObject.full_body || {})[1]?.toString() || '');
    data.append('ob[name]', (mainObject.full_name || {})[1]?.toString() || '');
    data.append('ob[weight]', parseInt(mainObject?.weight?.toString() || '100', 10).toString());
    data.append('ob[extra_data][numerals]', mainObject.extra_data?.numerals || 'normal');
    data.append('ob[is_open_order]', !!mainObject.is_open_order ? '1' : '0');
    data.append('ob[quiz_id]', mainObject?.quiz_id?.toString() || '');

    Object.keys(mainObject.full_body || {}).map((key) => {
      if (parseInt(key, 10) !== 1) {
        data.append(`translations[body][${key}]`, (mainObject.full_body || {})[parseInt(key, 10)]?.toString() || '');
      }
    });
    Object.keys(mainObject.full_name || {}).map((key) => {
      if (parseInt(key, 10) !== 1) {
        data.append(`translations[name][${key}]`, (mainObject.full_name || {})[parseInt(key, 10)]?.toString() || '');
      }
    });
    
    mutationSave.mutate({
      formData: data
    });
  };
  
  // useEffect(() => {
  //   if (!!object) {
  //     setTimeout(() => {setMainObject({...object});}, 200);
  //   }
  // }, [object]);
  
  useEffect(() => {
    // console.log(mainObject, object, objectId, open, objectSuccess);
    if (!!objectSuccess) {
      setTimeout(() => {setMainObject({...object});}, 250);
    }
  }, [objectSuccess, object]);
  
  // useEffect(() => {
  //   console.log("mo", mainObject);
  // }, [mainObject]);
  
  useEffect(() => {
    // console.log('open', open, objectId);
    if (!objectId) setMainObject({name: ''});
    if (!!objectId) objectRefetch();
  }, [objectId]);

  return (<>
    <Base
      name="add_subject"
      title={t("coach.knowledge_subjects.dialogs.add_edit")}
      maxWidth='xl'
      onClose={() => {
        if (!!setObjectId) setObjectId(undefined);
        setMainObject({name: ''});
      }}
      content={<>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{marginTop: 4}}>
            <Typography variant="h5">{t("coach.submenu.subject_sections.general")}</Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
            <AppBar position="static" sx={{backgroundColor: theme.palette.primary.contrastText}}>
              <Tabs value={currentLanguageId} onChange={(ev, i) => {
                setCurrentLanguageId(i);
                setFlickerEditor(true);
                setTimeout(() => {setFlickerEditor(false);}, 200);
              }}>
                {(knowledgeCourse.access_data?.availability || [1]).map(mmm => HelpersLanguage.mapping_to_iso(mmm)).map((locale, i) => {
                  return (<Tab value={HelpersLanguage.mapping_to_id(locale)} label={locale.toUpperCase()} id={`locale_tab_${locale}`} />)
                })}
              </Tabs>
            </AppBar>
          </Grid>
          <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
            <TextInput
              id="name"
              caption={t("general.knowledge_subjects.fields.name")}
              starred
              value={(mainObject?.full_name || {})[currentLanguageId] || ""}
              onChange={(e) => {
                setMainObject({
                  ...mainObject,
                  full_name: {
                    ...(mainObject.full_name || {}),
                    [currentLanguageId]: e
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
            <Typography sx={{fontSize: '0.8rem'}}>{t("general.knowledge_subjects.fields.body")}</Typography>
            {!flickerEditor && <Editor
              knowledge
              label=""
              value={(mainObject?.full_body || {})[currentLanguageId] || ""}
              onChange={(e) => {
                setMainObject({
                  ...mainObject,
                  full_body: {
                    ...(mainObject.full_body || {}),
                    [currentLanguageId]: e
                  }
                });
              }}
            />}
          </Grid>
          <Grid item xs={12} sx={{marginTop: 4}}>
            <Typography variant="h5">{t("coach.submenu.subject_sections.order")}</Typography>
            <Divider />
          </Grid>
          {!!knowledgeCourse.is_open_order && <Grid item xs={12} sx={{marginTop: 1}}>
            <Typography html sx={{
              borderRadius: 1,
              border: '1px solid transparent',
              borderColor: theme.palette.warning.main,
              padding: 1,
              textAlign: 'center'
            }}>{t("knowledge_subjects.warnings.course_has_open_order")}</Typography>
          </Grid>}
          <Grid item xs={12} md={6}>
            <TextInput
              id="weight"
              caption={t("coach.models.knowledge_subjects.weight")}
              value={mainObject.weight?.toString() || ''}
              onChange={(e) => {
                setMainObject({
                  ...mainObject,
                  weight: !!e ? (isNaN(parseInt(e || '100', 10)) ? undefined : parseInt(e || '100', 10)) : undefined
                });
              }}
            />
          </Grid>
          
          <Grid item xs={12} sx={{marginTop: 4}}>
            <Typography variant="h5">{t("coach.submenu.subject_sections.lessons")}</Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            <Switcher
              id="is_open_order"
              caption={t("general.knowledge_subjects.fields.is_open_order")}
              value={!!mainObject?.is_open_order}
              onChange={(c) => {
                setMainObject({
                  ...mainObject,
                  is_open_order: !!c
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Select
              fullWidth
              caption={t("coach.models.knowledge_subjects.numerals")}
              displayEmpty
              id="numerals"
              value={mainObject.extra_data?.numerals || 'normal'}
              setValue={(v) => {
                setMainObject({
                  ...mainObject,
                  extra_data: {
                    ...(mainObject?.extra_data || {}),
                    numerals: v?.toString()
                  }
                });
              }}
            >
              <MenuItem value=''>--- ---</MenuItem>
              <MenuItem value='normal'>1. 2. 3. 4. 5.</MenuItem>
              <MenuItem value='roman'>I. II. III. IV. V.</MenuItem>
              <MenuItem value='romansmall'>i. ii. iii. iv. v.</MenuItem>
              <MenuItem value='alphabet'>A. B. C. D. E.</MenuItem>
              <MenuItem value='alphabetsmall'>a. b. c. d. e.</MenuItem>
            </Select>
          </Grid>
          
          <Grid item xs={12} sx={{marginTop: 4}}>
            <Typography variant="h5">{t("coach.submenu.subject_sections.quiz")}</Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            <Select
              fullWidth
              caption={t("general.knowledge_subjects.fields.quiz_id")}
              backend
              displayEmpty
              id="quiz_id"
              value={mainObject.quiz_id?.toString() || ''}
              setValue={(v) => {
                setMainObject({
                  ...mainObject,
                  quiz_id: !!v ? parseInt(v.toString(), 10) : undefined
                });
              }}
            >
              <MenuItem value=''>--- ---</MenuItem>
              {(questionnaires || []).filter(fff => fff.content_type === 'quiz').map(questionnaire => <MenuItem value={questionnaire.id}>{questionnaire.name}</MenuItem>)}
            </Select>
          </Grid>
        </Grid>
      </>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn
          disabled={mutationSave.isPending}
          onClick={(e) => {
            if (!!setObjectId) setObjectId(undefined);
            setOpen(false);
          }}
          color="primary"
        >{t("coach.general.actions.cancel")}</Btn>
        <Btn
          disabled={mutationSave.isPending || Object.values(mainObject.full_name || {}).filter(fff => !!fff).length < 1}
          onClick={(e) => {
            saveObject();
          }}
          color="primary"
        >{t("client.general.actions.save")}</Btn>
      </DialogActions>}
      open={open}
      setOpen={setOpen}
    />
  </>);
}
